/**
 * Module with several utility functions.
 */
(function() {

  "use strict";

  define('fg-arv/utils',[],function() {

    var utils = {
      //------------------------------------------------------------------------------------------------------------------------------
      /**
       * Checks is a specific value is a function or not.
       *
       * @param value Value to check.
       * @returns {boolean} 'true' is the value is a function, 'false' otherwise;
       */
      isFunction: function(value) {
        if (value) {
          return typeof value === 'function';
        }
        return false;
      },

      //------------------------------------------------------------------------------------------------------------------------------
      /**
       * Checks is a specific value is a date or not.
       *
       * @param value Value to check.
       * @returns {boolean} 'true' is the value is a date, 'false' otherwise;
       */
      isDate: function(value) {
        return value instanceof Date;
      },

      isAfterToday: function(value) {
        if (utils.isDate(value)) {
          var tomorrow = new Date().add(1).days();
          return value.getTime() >= tomorrow.getTime();
        }
        return false;
      },
      //------------------------------------------------------------------------------------------------------------------------------
      /**
       * Checks if an object has a particular property and such property has a 'defined' value.
       * @param obj Any object.
       * @param {string} propertyName The name of the property to be checked.
       * @returns {boolean} true if the object has the property and the property value is not 'undefined', false otherwise.
       */
      isPropertyDefined: function(obj, propertyName) {
        return obj && propertyName && obj.hasOwnProperty(propertyName) && typeof obj[propertyName] !=
          'undefined';
      },

      //------------------------------------------------------------------------------------------------------------------------------
      /**
       * Returns a property value if the object has that property a its value is defined, null otherwise.
       * @param obj Any object.
       * @param {string} propertyName The name of the property from which to obtain the value.
       * @returns The property value if the object has that property a its value is defined, null otherwise.
       */
      getPropertyValue: function(obj, propertyName) {
        if (this.isPropertyDefined(obj, propertyName)) {
          return obj[propertyName];
        }
        return null;
      },

      isString: function(value) {
        return typeof(value) === 'string' || value instanceof String;
      },
      getLocalTime: function(coord, time, apiObject) {
        var deferredTime = new jQuery.Deferred(),
          _this = this,
          localTime, timeObject = {};
        this.getTimeOffset(coord, time, apiObject).done(function(offset) {
          localTime = _this.getTimeInLocalGMT(time.value, offset);
          timeObject = {
            value: _this.normalizeTime(localTime),
            gmt: _this.getGMT(offset)
          };
          deferredTime.resolve(timeObject);
        });
        return deferredTime.promise();
      },
      getTimeOffset: function(coord, time, apiObject) {
        var deferredOffset = new jQuery.Deferred();
        if (!coord) {
          deferredOffset.resolve(0);
        } else {
          if (time.text) {
            deferredOffset.resolve(this.getTimeOffsetByText(time.value, time.text));
          } else {
            this.getTimeOffsetByCoord(coord, time.value, apiObject).then(function(offset) {
              deferredOffset.resolve(offset);
            }, function() {
              deferredOffset.resolve(0);
            });
          }
        }
        return deferredOffset.promise();
      },
      getTimeOffsetByText: function(time, text) {
        var hour = parseInt(text.split(':')[0]);
        if ((text.split(':')[1].substring(2, 4) === 'pm' && hour !== 12) ||
          (text.split(':')[1].substring(2, 4) === 'am' && hour === 12)) {
          hour += 12;
          if (hour === 24) {
            hour = 0;
          }
        }
        return (hour - new Date(time).getHours()) * 60;
      },
      getTimeOffsetByCoord: function(coord, time, apiObject) {

        var offset = 0,
          deferred = new jQuery.Deferred(),
          lat, lng;
        if (!coord || !time || !apiObject.getAPIKey || !apiObject.getAPIKey()) {
          deferred.resolve(0);
        } else {
          setTimeout(function() {
            lat = typeof(coord.lat) === 'number' ? coord.lat : typeof(coord.lat) === 'function' ?
              coord
              .lat() : coord.A;
            lng = typeof(coord.lng) === 'number' ? coord.lng : typeof(coord.lng) === 'function' ?
              coord
              .lng() : coord.F;
            jQuery.ajax({
              url: 'https://maps.googleapis.com/maps/api/timezone/json?location=' +
                lat + ',' + lng + '&timestamp=' + time / 1000 + '&sensor=false&key=' + apiObject.getAPIKey(),
              success: function(data) {
                offset = (data.rawOffset - data.dstOffset) / 60;
                deferred.resolve(offset);
              },
              error: function() {
                offset = 0;
                deferred.resolve(offset);
              }
            });
          }, 500);

        }

        return deferred.promise();
      },
      addHour: function(text, hour) {
        return (parseInt(text.split(':')[0]) + hour) + ':' + text.split(':')[1];
      },
      getTimeInLocalGMT: function(time, timezoneOffset) {
        var newTime = new Date(time).getTime() + timezoneOffset * 60000;
        return newTime;
      },
      getGMT: function(timezoneOffset) {
        var gmt = new Date().toString().substring(28, 30),
          offset = new Date().getTimezoneOffset() - timezoneOffset;
        return 'GMT' + (gmt - (offset / 60));
      },

      normalizeTime: function(time) {
        time = new Date(time);
        return time.getHours() + ':' + (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes());
      },
      getUrlParam: function(sParam) {
        var sPageURL = window.location.search.substring(1),
          sURLVariables,
          sParameterName,
          i;
        if (sPageURL.search('&amp;') !== -1) {
          sURLVariables = sPageURL.split('&amp;');
        } else {
          sURLVariables = sPageURL.split('&');
        }
        for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = decodeURIComponent(sURLVariables[i]).split('=');

          if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
          }
        }
      },
      //------------------------------------------------------------------------------------------------------------------------------
      createEventBus: function(data) {
        var eventHandlers = {};
        var eventBus = {
          getData: function() {
            return data;
          },
          addHandler: function(eventName, callbackFunction) {
            var handlers = utils.getPropertyValue(eventHandlers, eventName);
            if (!handlers) {
              eventHandlers[eventName] = [];
            }
            if (eventHandlers[eventName].indexOf(callbackFunction) < 0) {
              eventHandlers[eventName].push(callbackFunction);
            }
            return this;
          },
          removeHandler: function(eventName, callbackFunction) {
            var handlers = utils.getPropertyValue(eventHandlers, eventName);
            if (handlers && handlers.length > 0) {
              var index = eventHandlers[eventName].indexOf(callbackFunction);
              if (index > -1) {
                eventHandlers[eventName].splice(index, 1);
              }
            }
            return this;
          },
          trigger: function() {
            if (arguments && arguments.length > 0) {
              var eventName = arguments[0];
              var handlers = utils.getPropertyValue(eventHandlers, eventName);
              if (handlers && handlers.length > 0) {
                var args = [];
                for (var x = 1; x < arguments.length; x++) {
                  args.push(arguments[x]);
                }
                var context = {
                  eventBus: eventBus,
                  eventName: eventName
                };
                args.push(context);
                jQuery.each(handlers, function(index, handler) {
                  return handler.apply(handler, args);
                });
              }
            }
          }
        };
        return eventBus;
      },
      getBoundsZoomLevel: function(bounds, mapDim) {
        var WORLD_DIM = {
          height: 256,
          width: 256
        };
        var ZOOM_MAX = 21;

        function latRad(lat) {
          var sin = Math.sin(lat * Math.PI / 180);
          var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
          return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
        }

        function zoom(mapPx, worldPx, fraction) {
          return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
        }

        var ne = bounds.getNorthEast();
        var sw = bounds.getSouthWest();

        var latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

        var lngDiff = ne.lng() - sw.lng();
        var lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;

        var latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
        var lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);

        return Math.min(latZoom, lngZoom, ZOOM_MAX);
      }
    };

    return utils;
  });

})();

